import { Component } from '@angular/core';
import { StateService, ThemeLayoutState } from '../../../@core/services/state.service';

@Component({
  selector: 'ngx-theme-settings',
  styleUrls: ['./theme-settings.component.scss'],
  templateUrl: `./theme-settings.component.html`,
})
export class ThemeSettingsComponent {

  layouts: ThemeLayoutState[] = [];
  sidebars: ThemeLayoutState[] = [];

  constructor(protected readonly stateService: StateService) {
    this.stateService.getLayoutStates()
      .subscribe((layouts: ThemeLayoutState[]) => this.layouts = layouts);

    this.stateService.getSidebarStates()
      .subscribe((sidebars: ThemeLayoutState[]) => this.sidebars = sidebars);
  }

  layoutSelect(layout: ThemeLayoutState): boolean {
    this.layouts = this.layouts.map((l: ThemeLayoutState) => {
      l.selected = false;
      return l;
    });

    layout.selected = true;
    this.stateService.setLayoutState(layout);
    return false;
  }

  sidebarSelect(sidebars: ThemeLayoutState): boolean {
    this.sidebars = this.sidebars.map((s: ThemeLayoutState) => {
      s.selected = false;
      return s;
    });

    sidebars.selected = true;
    this.stateService.setSidebarState(sidebars);
    return false;
  }
}
